import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import plusIcon from "../../../assets/images/Svg/plusIcon.svg";
import AddMedication from "./AddMedication";
import MedicalService from "../../../Services/MedicalService";
import dayjs from "dayjs";
import { FiPlus } from "react-icons/fi";

function Medication(props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [medicationData, setMedication] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    patientMedication();
  }, [props.selectedPatient.patientId]);

  const handleMedicationClick = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    patientMedication();
  };

  const patientMedication = () => {
    let payload = {
      patientCode: props.selectedPatient.patientId,
      status: 1,
    };
    MedicalService.PatientMedication(payload)
      .then((result) => {
        setMedication(result.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div>
      {/* <div className="card h-[300px] m-5 border rounded-lg">
        <div className="header h-[15%] bg-secondaryColor flex items-center justify-between rounded-lg p-2">
          <h1 className="font-bold text-normal text-white">Medication</h1>
          <img
            src={plusIcon}
            onClick={() => handleMedicationClick()}
            className="h-10 w-10 cursor-pointer"
            alt=""
          />
        </div>
        <div className="body h-[70%] overflow-y-auto bg-brand-lightBg p-2" id="unquie-scroll">
          {medicationData.length > 0
            ? medicationData.map((user, i) => (
                <div>
                  <div key={i} className="flex flex-col gap-2 mt-3 text-sm">
                    <p className="font-medium text-black">Drug Name : <span className="font-medium text-gray-500">{user.drugName}</span></p>
                    <p className="font-medium text-black">Composition : <span className="font-medium text-gray-500">{user.composition ? user.composition : "N/A"}</span> </p>
                    <p className="font-medium text-black">Dosage : <span className="font-medium text-gray-500">{user.dosage} </span></p>
                    <p className="font-medium text-black">Frequency : <span className="font-medium text-gray-500">{user.frequency}</span> </p>
                    <p className="font-medium text-black">Duration : <span className="font-medium text-gray-500">{user.duration} {user.durationType}</span> </p>
                    <p className="font-medium text-black">Indication : <span className="font-medium text-gray-500">{user.indication}</span> </p>
                    <p className="font-medium text-black">Side Effects : <span className="font-medium text-gray-500">{user.sideEffects}</span> </p>
                    <p className="font-medium text-black">Compliance : <span className="font-medium text-gray-500">{user.compliance}</span> </p>
                    <p className="font-medium text-black">Adverse Effects : <span className="font-medium text-gray-500">{user.adverseEffects}</span> </p>
                    <p className="font-medium text-black">
                      Advice related to medicines : <span className="font-medium text-gray-500">{user.adviceRelatedMedicine}</span>
                    </p>
                   
                    <p className="text-gray-500 font-medium">
                      Onset date :{" "}
                      {dayjs(user.givenDate).format('YYYY-MM-DD')}
                    </p>
                  </div>
                  <hr className="my-4 border-gray-300" />
                </div>
              ))
            : null}
        </div>
        <div className="footer h-[10%]  bg-secondaryColor rounded-md"></div>
      </div> */}

      <div
        className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
        id="unquie-scroll"
      >
        <div className="flex justify-between items-center p-3">
          <h3 className="text-sm font-bold text-gray-700">Medication</h3>
          <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
            <div
              onClick={() => handleMedicationClick()}
              className="w-6 h-6 rounded-full flex items-center justify-center bg-primaryColor"
            >
              <FiPlus className="text-white w-4 h-4" />
            </div>
            {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
          </div>
        </div>
        <hr />
        <div className="h-44 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
          {medicationData.length > 0 ? (
            medicationData.map((user, i) => (
              <div
                className="relative"
                onMouseEnter={() => setHoveredIndex(i)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                  <div className="bg-[#FFF8FB] border border-[#FFA2CB] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                    <p>
                      <strong>Drug Name:</strong> {user.drugName}
                    </p>
                    <p>
                      Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                </div>
                {hoveredIndex === i && (
                  <div
                    className="fixed bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50"
                    style={{ top: "200px", left: "400px" }}
                  >
                    {" "}
                    {user.drugName && (
                      <p>
                        <strong>Drug Name:</strong> {user.drugName}
                      </p>
                    )}
                    {user.composition && (
                      <p>
                        <strong>Composition:</strong> {user.composition}
                      </p>
                    )}
                    {user.dosage && (
                      <p>
                        <strong>Dosage:</strong> {user.dosage}
                      </p>
                    )}
                    {user.frequency && (
                      <p>
                        <strong>Frequency:</strong> {user.frequency}
                      </p>
                    )}
                    {user.duration && (
                      <p>
                        <strong>Duration:</strong> {user.duration}
                      </p>
                    )}
                    {user.indication && (
                      <p>
                        <strong>Indication:</strong> {user.indication}
                      </p>
                    )}
                    {user.sideEffects && (
                      <p>
                        <strong>Side Effects:</strong> {user.sideEffects}
                      </p>
                    )}
                    {user.compliance && (
                      <p>
                        <strong>Compliance:</strong> {user.compliance}
                      </p>
                    )}
                    {user.adverseEffects && (
                      <p>
                        <strong>Adverse Effects:</strong> {user.adverseEffects}
                      </p>
                    )}
                    {user.adviceRelatedMedicine && (
                      <p>
                        <strong> Advice related to medicine:</strong>{" "}
                        {user.adviceRelatedMedicine}
                      </p>
                    )}
                    <p>
                      <strong>Onset date:</strong>{" "}
                      {dayjs(user.givenDate).format("YYYY-MM-DD")}
                    </p>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div></div>
          )}
        </div>
      </div>

      {isModalVisible && (
        <Modal
          title={
            <span className="text-xl font-bold font-sans">Add Medication</span>
          }
          visible={isModalVisible}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width={600}
          maskClosable={false}
        >
          <AddMedication
            selectedPatient={props.selectedPatient}
            onClose={() => handleCloseModal()}
          />
        </Modal>
      )}
    </div>
  );
}

export default Medication;
